import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconDone = createIcon({
  viewBox: '0 0 36 36',
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM26.5825 12.7908C26.0257 12.2364 25.1229 12.2364 24.5662 12.7908L15.7723 21.5475L11.4339 17.2275C10.8772 16.673 9.97443 16.673 9.41764 17.2275C8.86085 17.7819 8.86085 18.6808 9.41764 19.2352L14.7642 24.5592C15.321 25.1136 16.2237 25.1136 16.7805 24.5592L26.5825 14.7986C27.1392 14.2442 27.1392 13.3453 26.5825 12.7908Z"
      fill="#3EA69B"
    />
  ),
});

export default IconDone;
